import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function shorthandAddress(address: string, chars = 4) {
	return `${address.slice(0, chars)}...${address.slice(-chars)}`
}
